// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //API_URL: "http://localhost:4080/api",
  API_URL: "https://grp.admin.api.stackcode.io/api",
  API_KEY: 'AIzaSyCrZ-PCdMwb-BPEWO346VlgpWtcGl7sGhQ'
};
